import React from "react";

interface ImportIllustrationProps {
  className?: string;
}

export const ImportIllustration: React.FC<ImportIllustrationProps> = ({
  className = "h-24 w-24",
}) => {
  return (
    <svg
      className={className}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      {/* Box */}
      <path
        d="M30 42L60 24L90 42V78L60 96L30 78V42Z"
        className="fill-primary-50 stroke-primary-300"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      {/* Box flaps */}
      <path
        d="M30 42L60 60L90 42"
        className="stroke-primary-300"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M60 60V96"
        className="stroke-primary-300"
        strokeWidth="2"
        strokeLinecap="round"
      />
      {/* Down arrow */}
      <circle
        cx="60"
        cy="28"
        r="12"
        className="fill-success-100 stroke-success-500"
        strokeWidth="2"
      />
      <path
        d="M60 24V32M60 32L56 28M60 32L64 28"
        className="stroke-success-600"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Small meal dots */}
      <circle cx="44" cy="72" r="4" className="fill-warning-300" />
      <circle cx="56" cy="80" r="4" className="fill-secondary-300" />
      <circle cx="72" cy="76" r="4" className="fill-primary-300" />
    </svg>
  );
};

export default ImportIllustration;
